// extracted by mini-css-extract-plugin
export default {"base":"frequently-asked-questions-module__base--zop","heading":"frequently-asked-questions-module__heading--zCb","subtitle":"frequently-asked-questions-module__subtitle--jkX"};